/**
 * Build Your Box — free gift lifecycle.
 * Rules (spec #4):
 *  - Gift is added by build-your-box.js in the same cart/add payload as the subscription (qty 1, no selling_plan).
 *  - If no qualifying BYOB subscription line remains in cart -> remove the gift.
 *  - Never more than 1 gift unit / 1 gift line.
 * Gift lines are identified by line property `_byob_gift=true`; qualifying lines by
 * `_byob_subscription=true` + a selling_plan_allocation (Appstle recurring line).
 */
(function () {
  if (window.__byobGiftLoaded) return;
  window.__byobGiftLoaded = true;
  var syncing = false;

  function sectionIds() {
    try {
      if (window.Alpine && Alpine.store('xCartHelper')) {
        return Alpine.store('xCartHelper').getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (e) {}
    return [];
  }

  function change(key, qty) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: sectionIds() })
    }).then(function (r) { return r.json(); }).then(function (data) {
      try {
        if (data.sections && window.Alpine && Alpine.store('xCartHelper')) {
          Alpine.store('xCartHelper').reRenderSections(data.sections);
        }
      } catch (e) {}
      return data;
    });
  }

  function sync() {
    if (syncing) return Promise.resolve();
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var gifts = items.filter(function (i) { return i.properties && i.properties._byob_gift === 'true'; });
        if (!gifts.length) return null;
        var qualifying = items.some(function (i) {
          return i.properties && i.properties._byob_subscription === 'true' && !!i.selling_plan_allocation;
        });
        var ops = [];
        syncing = true;
        if (!qualifying) {
          gifts.forEach(function (g) { ops.push(function () { return change(g.key, 0); }); });
        } else {
          // Keep exactly one gift unit on the first gift line; drop extra gift lines.
          gifts.forEach(function (g, idx) {
            if (idx === 0 && g.quantity !== 1) ops.push(function () { return change(g.key, 1); });
            if (idx > 0) ops.push(function () { return change(g.key, 0); });
          });
        }
        if (!ops.length) { syncing = false; return null; }
        // Sequential: parallel cart/change calls on the same cart can race.
        return ops.reduce(function (chain, op) { return chain.then(function () { return op(); }); }, Promise.resolve())
          .then(function () { document.dispatchEvent(new CustomEvent('eurus:cart:items-changed')); })
          .finally(function () { syncing = false; });
      })
      .catch(function () { syncing = false; });
  }

  window.BYOBGiftSync = sync;
  document.addEventListener('eurus:cart:items-changed', function () { setTimeout(sync, 350); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
